"use client";
import { useState, useEffect } from "react";
import { useTheme } from "next-themes";
import { MoonIcon, SunIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type Theme = "system" | "dark" | "light";
export function useThemeSwitch(): { theme: Theme | undefined; setTheme: ((t: Theme) => void) | undefined; toggleTheme: (() => void) | undefined } {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return { theme: undefined, setTheme: undefined, toggleTheme: undefined };
  }

  return { theme: theme as Theme | undefined, setTheme, toggleTheme: () => setTheme((p) => (p === "light" ? "dark" : "light")) };
}

const ThemeSwitch = () => {
  const { theme, setTheme } = useThemeSwitch();
  return (
    <select value={theme} onChange={(e) => setTheme?.(e.target.value as Theme)}>
      <option value="system">System</option>
      <option value="dark">Dark</option>
      <option value="light">Light</option>
    </select>
  );
};

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useThemeSwitch();
  return (
    <div onClick={toggleTheme} className={cn("flex cursor-pointer items-center gap-1 ", className)}>
      Тема {theme === "light" ? <MoonIcon className="size-4" /> : <SunIcon className="size-4" />}
    </div>
  );
}
